module.exports = __webpack_public_path__ + "img/banner-cableado.fc496312.jpeg";